import axios from 'axios';
import { REACT_APP_API_BASE_URL } from '../apiurl';

// Create axios instance
const api = axios.create({
  baseURL: `${REACT_APP_API_BASE_URL}api`,
  timeout: 30000, // 30 seconds default
  withCredentials: true,
});

// Request interceptor
api.interceptors.request.use(
  (config) => {

    // Don't set Content-Type for FormData (browser will set it with boundary)
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }

    return config;
  },
  (error) => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

// ─── Timezone Fix ────────────────────────────────────────────
// Backend returns IST timestamps incorrectly tagged as UTC (Z suffix).
// This recursively strips the Z / +00:00 from all ISO date strings
// so JavaScript treats them as local time, preventing double conversion.
const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?(Z|\+00:00)$/;

function fixTimestamps(data) {
  if (data === null || data === undefined) return data;

  if (typeof data === 'string' && ISO_DATE_REGEX.test(data)) {
    return data.replace('Z', '').replace('+00:00', '');
  }

  if (Array.isArray(data)) {
    return data.map(fixTimestamps);
  }

  if (typeof data === 'object') {
    const fixed = {};
    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        fixed[key] = fixTimestamps(data[key]);
      }
    }
    return fixed;
  }

  return data;
}

// Response interceptor
api.interceptors.response.use(
  (response) => {
    response.data = fixTimestamps(response.data);
    return response.data;
  },
  (error) => {
    console.error('API Error:', {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status,
      url: error.config?.url,
    });

    // Format error
    const formattedError = {
      message: error.response?.data?.message || error.message || 'An error occurred',
      status: error.response?.status,
      data: error.response?.data,
    };

    // Handle specific errors
    if (error.response?.status === 401) {
      // localStorage.removeItem('token');
      // window.location.href = '/login';
    }

    if (error.response?.status === 413) {
      formattedError.message = 'Request too large. Please reduce file sizes.';
    }

    if (error.code === 'ECONNABORTED') {
      formattedError.message = 'Request timeout. Please try again.';
    }

    return Promise.reject(formattedError);
  }
);



export default api;